editForkWithDelayBoxController.$inject = ['$scope',
    '$mdDialog',
    '$translate',
    'elementData',
    'elementView'];

export function editForkWithDelayBoxController($scope,
                                               $mdDialog,
                                               $translate,
                                               elementData,
                                               elementView) {

    $scope.ok = ok;
    $scope.cancel = cancel;

    init();
    function init() {
        $scope.elementData = elementData;
        $scope.elementView = elementView;
        initDelayUnitDropDownItem();
    }


    function initDelayUnitDropDownItem() {
        $scope.delayUnitDropdownItems = [{
            id: 'hours', 
            label: $translate.instant('parameters/quick_replies/details/graph/fork_with_delay_box/delay_hours')
          },{
            id: 'days', 
            label: $translate.instant('parameters/quick_replies/details/graph/fork_with_delay_box/delay_days')
        }];
    }

    function ok() {
        $mdDialog.hide({ type: 'ok', data: elementData });
    }

    function cancel() {
        $mdDialog.cancel();
    }
}